// extracted by mini-css-extract-plugin
module.exports = {"text":"checkbox_text__1tlxW","checkbox":"checkbox_checkbox__2wmYF","checkmark":"checkbox_checkmark__2jSgm","checkmarkContainer":"checkbox_checkmarkContainer__3gNQp"};